const ipBlockList = () => import("./views/ipBlockList.vue"); //ip黑名单

export default {
  //ip黑名单
  path: "/ipBlockList",
  name: "ipBlockList",
  component: ipBlockList,
  meta: {
    title: "ip黑名单",
    root: "/appCenter"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/ipBlockList/router.js